import { Component, EventEmitter, forwardRef, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DepotService } from 'app/pages/providers/components/depot/depot.service';
import { IDepot } from 'app/core/interfaces/depot.interface';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-subdivision-multi-select',
  templateUrl: './subdivision-multi-select.component.html',
  styleUrls: ['./subdivision-multi-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SubdivisionMultiSelectComponent),
      multi: true
    }
  ]
})
export class SubdivisionMultiSelectComponent implements OnInit, OnChanges, OnDestroy, ControlValueAccessor {
  @Input() emitOnlyId = false;
  @Input() providerId = false;
  @Input() placeHolder = 'Select';
  @Output() availableDepotsChange = new EventEmitter<IDepot[]>();
  isLoad = false;
  dropdownList: IDepot[] = [];
  selectedItems: IDepot[] = [];
  showMultiselect = false;
  private allDepots: IDepot[] = [];
  private selectedRegionIds: number[] = [];
  private subscriptions: Subscription[] = [];

  dropdownSettings = {
    singleSelection: false,
    idField: 'depotid',
    textField: 'shortcode',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 5,
    allowSearchFilter: false,
    enableCheckAll: false
  };
  public propagateChange: any = () => {};

  constructor(private service: DepotService) {
  }

  ngOnInit() {
    this.listenRegionChanges();
  }

  private listenRegionChanges(): void {
    this.subscriptions.push(
      this.service.selectedRegionIds$.subscribe({
        next: (regionIds: number[]) => {
          this.selectedRegionIds = regionIds || [];
          this.applyDepotFilter();
        },
      }),
    );
  }

  ngOnChanges() {
    if (this.providerId) {
      this.loadDepots();
    }
  }

  private loadDepots(): void {
    this.service
      .getDepootsByProvider(this.providerId)
      .subscribe({
        next: (res: IDepot[]) => {
          this.allDepots = res || [];
          this.applyDepotFilter();
        },
      });
  }

  private applyDepotFilter(): void {
    if (this.selectedRegionIds && this.selectedRegionIds.length) {
      this.dropdownList = this.allDepots.filter((depot: IDepot) =>
        this.selectedRegionIds.includes(Number(depot.regionid)),
      );
    } else {
      this.dropdownList = this.allDepots;
    }

    this.showMultiselect = this.dropdownList.length > 0;
    this.isLoad = true;
    this.syncSelectedItems();
    this.availableDepotsChange.emit(this.dropdownList);
  }

  private syncSelectedItems(): void {
    if (!this.selectedItems || !this.selectedItems.length) {
      return;
    }

    this.selectedItems = this.selectedItems.filter((item) =>
      this.dropdownList.some((depot: IDepot) => depot.depotid === item.depotid),
    );
    this.emitByType();
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
    if (obj) {
      this.selectedItems = this.resolveDepotsFromIds(obj);
    }
  }

  private resolveDepotsFromIds(obj: { depotid: number }[]): IDepot[] {
    return obj
      .map((item: { depotid: number }) => {
        return this.dropdownList.find((depot: IDepot) => {
          const itemDepotId = item.depotid != null ? item.depotid : item;
          return depot.depotid === itemDepotId;
        });
      })
      .filter((depot): depot is IDepot => !!depot);
  }

  /**
   * Propagate según Tipo
   */
  emitByType() {
    if (this.emitOnlyId) {
      const arrayEmit = this.selectedItems.map((item) => {
        return { depotid: item.depotid, description: item.description };
      });
      this.propagateChange(arrayEmit);
    } else {
      this.propagateChange(this.selectedItems);
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length) {
      this.subscriptions.forEach((subscription: Subscription) => {
        if (subscription) {
          subscription.unsubscribe();
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/multi-select-dropdown/subdivision-multi-select/subdivision-multi-select.component.ts